function getCompletionPercent(cropYear = {}) {
  const nextValue = Number(cropYear.completion_percent);

  if (!Number.isFinite(nextValue)) {
    return 0;
  }

  return Math.max(0, Math.min(100, nextValue));
}

function getCompletionTone(cropYear = {}) {
  const completionPercent = getCompletionPercent(cropYear);

  if (completionPercent >= 100) {
    return {
      label: "Complete",
      barClassName: "bg-green-500",
      textClassName: "text-green-700",
      chipClassName: "bg-green-100 text-green-800 border-green-200",
    };
  }

  if (completionPercent >= 40) {
    return {
      label: "In Progress",
      barClassName: "bg-amber-500",
      textClassName: "text-amber-700",
      chipClassName: "bg-amber-100 text-amber-900 border-amber-200",
    };
  }

  return {
    label: "Incomplete",
    barClassName: "bg-red-500",
    textClassName: "text-red-700",
    chipClassName: "bg-red-100 text-red-800 border-red-200",
  };
}

function formatMissingFieldName(fieldName) {
  return String(fieldName || "")
    .split("_")
    .filter(Boolean)
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1).toLowerCase())
    .join(" ");
}

function getMissingAnalysisFields(cropYear = {}) {
  if (!Array.isArray(cropYear.missing_analysis_fields)) {
    return [];
  }

  return cropYear.missing_analysis_fields.map(formatMissingFieldName);
}

export {
  formatMissingFieldName,
  getCompletionPercent,
  getCompletionTone,
  getMissingAnalysisFields,
};
